import Link from "@/components/common/Link";
import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";

export default function AboutArea() {
  const { messages } = useI18n();
  const aboutPage = messages.about.page;
  const features = aboutPage.features;
  const vision = aboutPage.vision;
  const goals = aboutPage.goals;

  return (
    <section className="about-section about-page-section">
      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="row align-items-center g-5 mb-5">
          <div className="col-12 col-md-6">
            <div className="about-img-wrapper">
              <div className="about-img pe-xxl-5 translateY10">
                <Image
                  className="tilt-image w-auto h-auto"
                  src="/assets/img/bg-img/image-3.jpg"
                  alt=""
                  width={500}
                  height={500}
                  priority
                />
              </div>
              {/* Decorative Element */}
              <div className="about-img-decoration"></div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="section-heading">
              <span className="subtitle">{messages.about.subtitle}</span>
              <h2 className="mb-4 color-change">{aboutPage.title}</h2>
              <p className="mb-4">{aboutPage.description}</p>

              {/* <!-- About List --> */}
              <ul className="list-unstyled about-list mb-5">
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon"></use>
                  </svg>
                  {features.item1}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon"></use>
                  </svg>
                  {features.item2}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon"></use>
                  </svg>
                  {features.item3}
                </li>
                <li>
                  <svg width="28" height="28">
                    <use href="#checkIcon"></use>
                  </svg>
                  {features.item4}
                </li>
              </ul>

              {/* <!-- Button --> */}
              <Link href="/contact" className="btn btn-primary">
                <span>{aboutPage.startPartnership} <i className="ti ti-arrow-up-right"></i></span>
                <span>{aboutPage.startPartnership} <i className="ti ti-arrow-up-right"></i></span>
              </Link>
            </div>
          </div>
        </div>

        {/* Vision and Goals Cards */}
        <div className="row g-4 mt-4">
          <div className="col-12 col-md-6">
            <div className="about-card vision-card">
              <div className="about-card-icon">
                <i className="ti ti-eye"></i>
              </div>
              <h5 className="mb-3">{vision.title}</h5>
              <ul className="list-unstyled about-list">
                <li>
                  <svg width="24" height="24">
                    <use href="#checkIcon"></use>
                  </svg>
                  {vision.items.item1}
                </li>
                <li>
                  <svg width="24" height="24">
                    <use href="#checkIcon"></use>
                  </svg>
                  {vision.items.item2}
                </li>
              </ul>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="about-card goals-card">
              <div className="about-card-icon">
                <i className="ti ti-target"></i>
              </div>
              <h5 className="mb-3">{goals.title}</h5>
              <ul className="list-unstyled about-list">
                <li>
                  <svg width="24" height="24">
                    <use href="#checkIcon"></use>
                  </svg>
                  {goals.items.item1}
                </li>
                <li>
                  <svg width="24" height="24">
                    <use href="#checkIcon"></use>
                  </svg>
                  {goals.items.item2}
                </li>
                <li>
                  <svg width="24" height="24">
                    <use href="#checkIcon"></use>
                  </svg>
                  {goals.items.item3}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>
    </section>
  )
}